
import { Component, Vue } from 'vue-property-decorator'
import { SelectOption } from '@/components/common/molecules/SelectWithLabel.vue'
import { StudyModeCodeType } from '@/constants/ApiConstant'

export type LoadGradesType = {
  id: number
  code: string
  name: string
  sort_num: number
}

export type StudyContentSelectType = {
  options: SelectOption[]
  studyModes: StudyModesType[]
}

export type StudyModesType = {
  studyContentId: number
  studyModeCode: StudyModeCodeType
}

export type SubjectSelectType = {
  options: SelectOption[]
  subjectDrillsStatus: SubjectDrillStatusType[]
}

export type SubjectDrillStatusType = {
  subjectCode: string
  availableStartLevels: number[]
  isSuspended: boolean | null
  isCompleted: boolean | null
}

/**
 * TestSelectionでのAPIリクエスト
 */
@Component
export default class StudySelectionApis extends Vue {
  /**
   * 学年一覧取得
   */
  protected async loadGrades(): Promise<SelectOption[]> {
    const { data }: { data: LoadGradesType[] } = await Vue.prototype.$http.httpWithToken.get('/v1/grades', {
      params: { onlyEnableStudy: true },
    })
    return data.map((loadGrade: LoadGradesType) => {
      return { value: loadGrade.code, text: loadGrade.name }
    })
  }

  /**
   * 科目一覧取得
   */
  protected async loadSubjects(studyContentId?: number): Promise<SubjectSelectType> {
    const { data }: { data: SubjectSelectType } = await Vue.prototype.$http.httpWithToken.get('/v1/subjects', {
      params: { isStudyStartSelection: true, studyContentId: studyContentId },
    })
    return data
  }

  /**
   * テスト一覧取得
   */
  protected async loadStudyContents(
    gradeCode?: string | null,
    branchId?: number | null
  ): Promise<StudyContentSelectType> {
    const { data }: { data: StudyContentSelectType } = await Vue.prototype.$http.httpWithToken.get(
      '/v1/study_contents',
      {
        params: { onlyEnableStudy: true, isStudyStartSelection: true, gradeCode: gradeCode, branchId: branchId },
      }
    )
    return data
  }

  /**
   * ドリル開始リクエスト
   * resultDrillId がレスポンスで返る
   */
  protected async studyStartApi(
    gradeCode: string,
    subjectCode: string,
    studyContentId: number,
    startLevel: number | null
  ): Promise<{ resultDrillId: number }> {
    const params = {
      gradeCode: gradeCode,
      subjectCode: subjectCode,
      studyContentId: studyContentId,
      startLevel: startLevel,
    }

    const { data }: { data: { resultDrillId: number } } = await Vue.prototype.$http.httpWithToken.post(
      '/v1/student/study/start',
      params
    )
    return data
  }

  /**
   * テスト開始前の動画取得
   */
  protected async loadVideoUrl(): Promise<string> {
    // 動画取得
    const result = await Vue.prototype.$http.httpWithToken.get('/v1/guide_movie')

    return result.data.url
  }
}
